import getLocal from '@/app/utils/getLocal';
import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import EfImg from '../ef-img';
import EfLink from '../ef-link';
import './index.scss';
import { langText } from './langText';

export interface EfCardRecommendProps {
    /**
     * 产品 tag
     */
    tag?: string;
    /**
     * 产品 productId
     */
    productId: string;
    /**
     * 产品 variantId
     */
    variantId: string;
    /**
     * 默认购买数量
     */
    quantity: number;
    /**
     * 库存
     */
    inventoryQuantity?: number;
    /**
     * 所有分辨率展示的资源链接
     */
    pc: string;
    /**
     * 分辨率小于等于1024px展示的资源链接
     */
    h5?: string;
    /**
     * label(处于标题之上的叫label)
     */
    label?: string;
    /**
     * 主标题
     */
    title?: string;
    /**
     * 副标题
     */
    subTitle?: string;
    /**
     * 描述
     */
    desc?: string;
    /**
     * 产品实际价格
     */
    price: number;
    /**
     * 产品对比价格
     */
    compareAtPrice: number;
    /**
     * 更多链接-文案
     */
    moreText?: string;
    /**
     * 更多链接-链接
     */
    moreLink?: string;
    /**
     * 购买按钮文案
     */
    buyText?: string;
    /**
     * 是否从购物车购买
     */
    isBuyInCar?: boolean;
    /**
     * 购买按钮点击回调
     */
    buyCallback?: (item: any) => void;
    /**
     * 是否置灰
     */
    disabled?: boolean;
    /**
     * 样式名
     */
    className?: string;
    /**
     * more
     */
    gtm_more_dataLayer?: any;
}

/**
 * 维护:谢保林
 *
 * 推荐卡片
 */
const EfCardRecommend: React.FC<EfCardRecommendProps> = ({
    tag,
    productId,
    variantId,
    quantity = 1,
    inventoryQuantity = 0,
    pc,
    h5,
    label,
    title,
    subTitle,
    desc,
    price,
    compareAtPrice,
    moreText,
    moreLink,
    isBuyInCar,
    buyText,
    buyCallback,
    className,
    disabled,
    gtm_more_dataLayer,
}) => {
    const prefixCls = `ef-card-recommend`;
    const [buyHref2, setBuyHref2] = useState(''); //购买链接
    const { locale } = getLocal();
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-disabled`]: disabled,
    });
    const textA = langText[locale] || langText['jp'];

    useEffect(() => {
        if (quantity && variantId && !isBuyInCar) {
            setBuyHref2(`https://${locale}.ecoflow.com/cart/${variantId}:${quantity}?channel=buy_button`);
        }
    }, [variantId, quantity]);

    // 点击购买
    const buyHandle = () => {
        buyCallback &&
            buyCallback({
                tag,
                productId,
                variantId,
                quantity,
                inventoryQuantity,
                pc,
                h5,
                label,
                title,
                subTitle,
                desc,
                price,
                compareAtPrice,
                moreText,
                moreLink,
                buyText,
                className,
                disabled,
            });
    };

    return (
        <div className={classes}>
            {tag && <span className={`${prefixCls}-tag`}>{tag}</span>}
            <div className={`${prefixCls}-img`}>{pc && <EfImg pc={pc} h5={h5} />}</div>
            <div className={`${prefixCls}-msg`}>
                {label && <div className={`${prefixCls}-label`}>{label}</div>}
                {title && <div className={`${prefixCls}-title`}>{title}</div>}
                {subTitle && <div className={`${prefixCls}-subTitle`}>{subTitle}</div>}
                {desc && <div className={`${prefixCls}-desc`}>{desc}</div>}
            </div>
            <div className={`${prefixCls}-footer`}>
                {price && (
                    <div className={`${prefixCls}-price`}>
                        {FormatMoneyLocal(price, locale)}
                        {<span className={`${prefixCls}-after`}>{textA.price_after}</span>}
                    </div>
                )}
                {compareAtPrice && (
                    <div className={`${prefixCls}-compareAtPrice`}>
                        {<span className={`${prefixCls}-before`}>{textA.compare_at_price_before}</span>}
                        {FormatMoneyLocal(compareAtPrice, locale)}
                        {<span className={`${prefixCls}-after`}>{textA.price_after}</span>}
                    </div>
                )}
                <div className={`${prefixCls}-link-box`}>
                    {moreText && moreLink && (
                        <EfLink href={moreLink} className={`${prefixCls}-link-buy`} dataLayer={gtm_more_dataLayer}>
                            {moreText}
                        </EfLink>
                    )}
                    {buyText && (
                        <EfLink
                            href={buyHref2}
                            className={`${prefixCls}-link-buy ${prefixCls}-link-buy-inventoryQuantity-${inventoryQuantity}`}
                            onClick={buyHandle}
                        >
                            {buyText}
                        </EfLink>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EfCardRecommend;
